import React from 'react'
import gql from 'graphql-tag'
import moment from 'moment'
import {Button} from 'antd'
import {CalendarOutlined} from '@ant-design/icons'
import Query from 'shared/components/Query'
import Layout from 'components/PrivateRoutes/Layout'
import {
  QueryParams,
  BookingsList,
  WeekNumberPicker,
  SearchField,
  Link,
} from 'components/shared'

const ListBookingsQuery = gql`
  query ListBookingsQuery($query: String, $after: DateTime, $before: DateTime, $first: Int, $sortDirection: SortDirection) {
    serviceProvider {
      id
      bookings(query: $query, startsAfterDateTime: $after, startsBeforeDateTime: $before, first: $first, sortByStartAt: $sortDirection) {
        ...BookingsList
      }
    }
  }
  ${BookingsList.fragments.bookingsList}
`


const ListBookings = (props) => {
  const now = moment()

  const getSearchVariables = (week, year, query) => {
    const variables = {
      first: 100,
      sortDirection: 'asc',
    }

    if (query) {
      variables.query = query
    }
    else {
      const selectedWeek = moment().set('year', year).isoWeek(week)
      variables.after = selectedWeek.startOf('isoWeek').format()
      variables.before = selectedWeek.endOf('isoWeek').format()
    }
    return variables
  }

  return (
    <QueryParams>
      {({queryParams, setQueryParams}) => {
        const query = queryParams.query || ''
        const week = parseInt(queryParams.week, 10) || now.isoWeek()
        const year = parseInt(queryParams.year, 10) || now.year()
        const variables = getSearchVariables(week, year, query)

        return (
          <Layout {...props} title="Bookinger">
            <SearchField
              className="list-search-field"
              placeholder="Søk i bookinger"
              query={query}
              onSearch={(query) => setQueryParams({query})}
            />

            {!query &&
              <div className="bookings-subnav">
                <Link to="/bookings/calendar">
                  <Button icon={<CalendarOutlined />} />
                </Link>
                <WeekNumberPicker
                  week={week}
                  year={year}
                  onChange={(week, year) => setQueryParams({week, year})}
                />
                <i /> {/* To ensure the week picker is still in the centre */}
              </div>
            }

            <Query
              query={ListBookingsQuery}
              variables={variables}
              inlineLoading
              inlineError
            >
              {({getData}) => {
                const bookings = getData('serviceProvider.bookings', {edges: []})

                if (bookings.edges.length === 0) {
                  if (variables.after && variables.before) {
                    return (
                      <div>Du har ingen bookinger denne perioden</div>
                    )
                  }
                  return (
                    <div>Ingen bookinger funnet for dette søket</div>
                  )
                }

                return <BookingsList bookings={bookings} />
              }}
            </Query>
          </Layout>
        )
      }}
    </QueryParams>
  )
}

export default ListBookings
